module.exports = __webpack_public_path__ + "static/media/bank-chase.456f8324.svg";